import React, { ReactNode, useState } from "react";
import { useNavigate } from "react-router-dom";
import LogoIcon from "../../assets/svg/logoIcon";
import BackButton from "./backButton";
import ChatHistory from "./chatHistory";
import Footer from "./footer";
import PaginationControls from "./adminTables/paginationControls";
import { Alert as AlertType } from "../../utils/interfaces";
import Alert from "./alerts/alert";
import Sidebar from "./sidebar";
import ChatHeader from "./chat/chatHeader";
import { useChat } from "../../context/chatContext";
import { useCases } from "../../utils/constants";
import { handleOptionSelect } from "../../utils/functions";

interface AdminLayoutProps {
  title: string | ReactNode;
  children: ReactNode;
  actionPanel?: ReactNode;
  formData: { results: any[]; total_count: number };
  currentPage: number;
  setCurrentPage: (page: number) => void;
  itemsPerPage: number;
  setItemsPerPage: (items: number) => void;
  alert?: AlertType;
  setAlert?: (alert: AlertType | null) => void;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({
  title,
  children,
  actionPanel,
  formData,
  currentPage,
  setCurrentPage,
  itemsPerPage,
  setItemsPerPage,
  alert,
  setAlert,
}) => {
  const navigate = useNavigate();
  
  const maxPages = Math.ceil(formData.total_count / itemsPerPage);
  const {
		selectedUseCase,
		selectedSubCase,
		chatId,
		renderFromHistory,
		conversation,
		showCards,
		setSelectedSubCase,
		setRenderFromHistory,
		setShowCards,
		startChat,
	} = useChat();

  const [isSelecting, setIsSelecting] = useState(false);
  const [initialQuestion, setInitialQuestion] = useState("");

  const handleSelect = async (index: number, question?: string) => {
		await handleOptionSelect(useCases, index, navigate, isSelecting, setIsSelecting);
		if(question){
			setInitialQuestion(question);
			console.log(question);
		}
	};
  return (
    <section className="mainScreen min-vh-100">
      <Sidebar />
      <div className="main-content">
        <ChatHeader useCase={selectedUseCase} selectUseCase={handleSelect} />

            <div
              className="card text-center mt-5 overflow-auto min-vh-80 max-vh-80"
              style={{ overflow: "auto", marginLeft: "1.5%", marginRight: "1.5%"}}
            >
              <div
                className="card-body"
                style={{
                  paddingLeft: "1.5%",
                  paddingRight: "1.5%",
                  overflow: "auto",
                  minHeight: "70vh",
                  maxHeight: "80vh",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  textAlign: "left",
                }}
              >
                <div className="mt-3 mx-2">
                  {typeof title === 'string' ? (
                    <h2 className="my-md-1" style={{
                      fontSize: '1.25rem',
                      fontWeight: 'bold',
                      fontFamily: 'Roboto',
                    }}>{title}</h2>
                  ) : (
                    <div className="my-md-1" style={{
                      fontSize: '1.25rem',
                      fontWeight: 'bold',
                      fontFamily: 'Roboto',
                    }}>{title}</div>
                  )}
                  {actionPanel && (
                    <div className="d-flex justify-content-end align-self-end align-items-end">
                      <div
                        className="w-100 d-flex flex-column gap-1 text-start"
                        style={{ width: "20%"}}
                      >
                        {actionPanel}
                      </div>
                    </div>
                  )}
                </div>
                <div className="flex-grow-1">
                  <div className="">
                    {children}
                  </div>
                </div>
                <PaginationControls
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  itemsPerPage={itemsPerPage}
                  setItemsPerPage={setItemsPerPage}
                  maxPages={maxPages}
                  formData={formData}
                />
                {/* <div className="mb-3">
                  <BackButton />
                </div> */}
                {alert && setAlert && (
                  <Alert
                    message={alert.message}
                    type={alert.type}
                    show={alert.show}
                    onClose={() => setAlert({ ...alert, show: false })}
                  />
                )}
              </div>
            </div>
  
          <Footer />
          <ChatHistory
            onNavigate={(path: string) => {
              navigate(path);
            }}
          />

      </div>
    </section>
  );
};

export default AdminLayout; 